export const createHistoryFeatures = (editor) => {
  const features = {
    canUndo: false,
    canRedo: false,

    updateHistoryButtons() {
      this.canUndo = editor ? editor.can().undo() : false;
      this.canRedo = editor ? editor.can().redo() : false;
    },

    undo() {
      if (!editor) return;
      editor.chain().focus().undo().run();
      this.updateHistoryButtons();
    },

    redo() {
      if (!editor) return;
      editor.chain().focus().redo().run();
      this.updateHistoryButtons();
    }
  };

  return features;
};
